export const createUserTV = (users = []) => {
  return users.map(u => {
    return {
      text: u.user_name,
      value: u.user_id
    };
  });
}

export const createUser = ({
  booking_report_flag = '',
  smtp_username = undefined,
  general_settings_flag = '',
  publishing_more_flag = '',
  signature_link = undefined,
  publishing_flag = '',
  staff_phone1 = undefined,
  staff_email = '',
  client_code = undefined,
  contacts_flag = '',
  smtp_password = undefined,
  booking_more_flag = '',
  staff_fullname = undefined,
  accounting_more_flag = '',
  job_title = undefined,
  label_flag = '',
  staff_phone2 = undefined,
  promotion_flag = '',
  management_flag = '',
  user_name = '',
  last_modified = '',
  contact_id = undefined,
  distribution_flag = '',
  language = '',
  smtp_server = undefined,
  password = '',
  permissions = '',
  booking_flag = '',
  contact_export_import_flag = '',
  dashboard_settings = '',
  label_more_flag = '',
  created = '',
  user_settings_flag = '',
  general_flag = '',
  module_settings_flag = '',
  accounting_flag = '',
  user_id = '',
  general_more_flag = ''
}) => {
  return {
    booking_report_flag,
    smtp_username,
    general_settings_flag,
    publishing_more_flag,
    signature_link,
    publishing_flag,
    staff_phone1,
    staff_email,
    client_code,
    contacts_flag,
    smtp_password,
    booking_more_flag,
    staff_fullname,
    accounting_more_flag,
    job_title,
    label_flag,
    staff_phone2,
    promotion_flag,
    management_flag,
    user_name,
    last_modified,
    contact_id,
    distribution_flag,
    language,
    smtp_server,
    password,
    permissions,
    booking_flag,
    contact_export_import_flag,
    dashboard_settings,
    label_more_flag,
    created,
    user_settings_flag,
    general_flag,
    module_settings_flag,
    accounting_flag,
    user_id,
    general_more_flag
  }
};